module.exports = __webpack_public_path__ + "img/18.9c0deff2.png";